import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset window scroll
    window.scrollTo({ top: 0, behavior: "instant" });

    // Reset scrollable containers (dash-content, dll)
    const containers = document.querySelectorAll(
      ".dash-content, .dash-main, main, [data-scroll]"
    );
    containers.forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}

